<template>
  <base-dialog
    width="560px"
    show-close
    :visible.sync="visible"
    class="save-slave-rule-dialog"
    v-ps="'.el-dialog__body'"
  >
    <template v-slot:header>编辑映射</template>
    <el-form
      ref="form"
      v-loading="loading"
      :model="syncRule"
      label-width="110px"
      :rules="rules"
      label-position="left"
    >
      <div class="form-group">
        <div class="title">基本信息</div>
        <div class="body">
          <el-form-item label="规则名称" prop="name">
            <el-input disabled v-model="syncRule.name"></el-input>
          </el-form-item>
          <el-form-item label="规则描述" prop="description">
            <el-input disabled v-model="syncRule.ruleMaster.description" type="textarea"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="form-group">
        <div class="title">同步信息</div>
        <div class="body">
          <el-form-item label="同步类型" prop="export">
            <el-select disabled v-model="syncRule.export">
              <el-option label="接收" :value="false"></el-option>
              <el-option label="输出" :value="true"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据源">
            <el-input
              disabled
              :value="syncRule.export ? curUser.companyName : syncRule.ruleMaster.companyName"
            ></el-input>
          </el-form-item>
          <el-form-item label="同步到">
            <el-input
              disabled
              :value="syncRule.export ? syncRule.ruleMaster.companyName : curUser.companyName"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作表" prop="sheetId">
            <el-select v-model="syncRule.sheetId" filterable @change="sheetChange">
              <el-option
                v-for="sheet in sheets"
                :key="sheet.sheetId"
                :label="sheet.name"
                :value="sheet.sheetId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="同步字段">
            <field-map-editor
              ref="fieldMapEditor"
              v-if="!loading"
              v-model="syncRule.connectInfo"
              :sheet-map="sheetMap"
              :sheet-id="syncRule.sheetId"
              :rule-master="syncRule.ruleMaster"
            ></field-map-editor>
            <base-button type="text" @click="syncRule.connectInfo = []">清空</base-button>
          </el-form-item>
          <el-form-item label="同步条件" prop="filters">
            <condition-editor :sheet="curSheet" v-model="syncRule.filters"></condition-editor>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import FieldMapEditor from "./FieldMapEditor"
import ConditionEditor from "./ConditionEditor"
import { updateSyncRuleSlave } from "@/api/connect"
import { getAvailableSheets } from "@/api/sheet/sheet"

export default {
  name: "save-slave-rule-dialog",
  components: { BaseDialog, BaseButton, FieldMapEditor, ConditionEditor },
  inject: ["app"],
  data() {
    return {
      visible: false,
      loading: false,
      syncRule: {
        ruleMaster: {}
      },
      companies: [],
      types: [],
      rules: {
        sheetId: [{ required: true, message: "请选择工作表", trigger: "blur" }],
        connectInfo: [{ required: true, message: "请填写映射关系", trigger: "blur" }]
      },
      debouncedRemoteMethod: null,
      searching: false,
      sheets: [],
      sheetMap: {}
    }
  },
  computed: {
    curSheet() {
      return this.sheetMap[this.syncRule.sheetId] || {}
    },
    curUser() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    open(syncRule) {
      this.syncRule = syncRule ? this._.cloneDeep(syncRule) : { export: true }
      this.syncRule.name = this.syncRule.ruleMaster?.name
      this.visible = true
      this.loading = true
      this.refreshSheets().then(() => (this.loading = false))
    },
    refreshSheets() {
      return Promise.all([
        getAvailableSheets({ appId: this.app.id, cache: false }).then(availableSheets => {
          let groupedSheets = availableSheets
          this.sheets = groupedSheets.find(app => app.id === this.app.id)?.sheets || []
          return groupedSheets
        }),
        getAvailableSheets({ appId: this.syncRule.ruleMaster?.appId, cache: false })
      ]).then(([curAppGroupedSheets, remoteAppGroupedSheets]) => {
        this.sheetMap = this._.chain(curAppGroupedSheets.concat(remoteAppGroupedSheets))
          .map(s => s.sheets)
          .flatten()
          .keyBy("sheetId")
          .value()
      })
    },
    sheetChange() {
      this.syncRule = Object.assign({}, this.syncRule, {
        connectInfo: [],
        filters: []
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        // 检查是否所有字段对应都已设置
        if (!this.$refs.fieldMapEditor.isAllFilled()) {
          this.$message.warning("请填写完整字段映射关系")
          return
        }
        updateSyncRuleSlave(this.syncRule).then(() => {
          this.$message.success("操作成功")
          this.visible = false
          this.$emit("change")
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.save-slave-rule-dialog {
  .el-select {
    width: 100%;
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
  }
  .form-group {
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
      margin-bottom: 14px;
    }
  }
  .field-map-editor {
    position: relative;
    left: -24px;
    width: 434px;
  }
}
</style>
